import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=7008cebc&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=7008cebc&prod&lang=stylus"
import style1 from "./GoodsInfo.vue?vue&type=style&index=1&id=7008cebc&prod&lang=stylus&scoped=true"
import style2 from "./GoodsInfo.vue?vue&type=style&index=2&id=7008cebc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008cebc",
  null
  
)

export default component.exports